import { motion } from "framer-motion";
import { CheckCircle, Clock, Award, Phone, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import BackgroundPattern from "@/components/BackgroundPattern";

const stats = [
  { icon: CheckCircle, value: "1,000+", label: "Projects Completed" },
  { icon: Clock, value: "20+", label: "Years Experience" },
  { icon: Award, value: "A+", label: "BBB Rating" },
];

const WhyZenithSection = () => (
  <section id="why-zenith" className="section-padding bg-primary text-primary-foreground relative">
    <BackgroundPattern variant="tealprint" className="text-primary-foreground" />
    <div className="container mx-auto max-w-6xl relative z-10">
      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-16">
        {stats.map((s, i) => (
          <motion.div
            key={s.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.1 }}
            className="text-center p-6 rounded-xl bg-primary-foreground/5 border border-primary-foreground/10"
          >
            <s.icon className="h-6 w-6 mx-auto mb-3 text-primary-foreground" />
            <p className="text-3xl md:text-4xl font-black text-primary-foreground">{s.value}</p>
            <p className="text-sm text-primary-foreground/70 mt-1 font-medium">{s.label}</p>
          </motion.div>
        ))}
      </div>

      {/* Story */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="text-center max-w-3xl mx-auto"
      >
        <p className="text-sm font-bold uppercase tracking-widest text-primary-foreground/60 mb-3">Our Promise</p>
        <h2 className="text-3xl md:text-4xl font-black mb-6">Founded on Integrity. Built on Trust.</h2>
        <p className="text-lg text-primary-foreground/80 leading-relaxed mb-4">
          We educate families on options, warranties, and incentives so you choose confidently—not pressured. Every
          project starts with a transparent conversation and ends with a handshake you can trust.
        </p>
        <p className="text-primary-foreground/60 italic mb-8">"We educate you first, deliver excellence second."</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="tel:5056048536">
            <Button
              size="lg"
              className="bg-white text-primary hover:bg-white/90 text-base font-bold h-14 px-8 gap-2 shadow-lg"
            >
              <Phone className="h-5 w-5" /> Call (505) 264-0170
            </Button>
          </a>
          <Link to="/get-estimate">
            <Button
              size="lg"
              className="bg-primary-foreground/10 border-2 border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground/20 hover:text-primary-foreground text-base font-bold h-14 px-8 gap-2"
            >
              Get Free Estimate <ArrowRight className="h-5 w-5" />
            </Button>
          </Link>
        </div>
      </motion.div>
    </div>
  </section>
);

export default WhyZenithSection;
